import React, { useEffect, useState, useRef } from "react";
import Navbar from "../Common/Navbar";
import { Link } from "react-router-dom";
import Lottie from "lottie-react";
import Loader from "../animation/Loader.json";
import CasePostModel from "./CasePostModel";
import { fetchApi } from "../utlis/axios";
import { FaDonate, FaUserCircle } from "react-icons/fa";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { MdDelete } from "react-icons/md";
import Banner from "../Common/Banner";
import { FaSearch, FaHeart } from "react-icons/fa";
import { Footer } from "../Footer/Footer";
import PostCase from "./PostCase";
import { BsEmojiSmile } from "react-icons/bs"; // Emoji icon
import EmojiPicker from "emoji-picker-react";
import { LuSend } from "react-icons/lu";
import { TbMessage } from "react-icons/tb";
import { Helmet } from "react-helmet";

const CasesFeeds = () => {
  const { role } = useSelector(
    (state) => state?.authSlice?.userInfo?.user || {}
  );
  const [searchQuery, setSearchQuery] = useState("");
  const [currentTab, setCurrentTab] = useState("Approved");
  const [showModel, setShowModel] = useState(false);
  const [commentValues, setCommentValues] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [commentLoading, setCommentLoading] = useState(false);
  const [feeds, setFeeds] = useState([]);
  const [editFeed, setEditFeed] = useState({});
  const [comments, setComments] = useState([]);
  const [isShowComment, setIsShowComment] = useState(null);
  const [hasMore, setHasMore] = useState(true);
  const [sending, setSending]=useState(null)
  const [page, setPage] = useState(1);
  const initialRender = useRef(true);
  const [commentsCounts, setCommentsCounts] = useState({});
  const [commentsPage, setCommentsPage] = useState({});
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [donationsCounts, setDonationsCounts] = useState({});
  const [postImages, setPostImages] = useState([]);
  const [postVideos, setPostVideos] = useState([]);
  const [newCaseModalOpen, setNewCaseModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const itemPerPage = 5;

  const [formValues, setFormValues] = useState({
    status: editFeed?.status,
    approved: editFeed?.is_approved,
  });

  const location = useLocation();
  useEffect(() => {
    if (location?.state?.previousUrl === "/postcase") {
      setCurrentTab("New");
    }
  }, []);

  const toggleShowmodel = (img, vid) => {
    setPostImages(img);
    setPostVideos(vid);
    setShowModel(true);
  };

  const submitComment = async (e, caseID) => {
    e.preventDefault();
    if (!commentValues[caseID]?.trim()) {
      toast.error("Please write a comment");
      return;
    }
    setSending(caseID)
    toast.success("Your messaage sending")
    setCommentValues((prev) => ({
      ...prev,
      [caseID]: "",
    }));
    try {
      const data = {
        case_id: caseID,
        is_active: true,
        text: commentValues[caseID] || "",
      };
      const result = await fetchApi.post("case-comment/", data);
      if (result?.status === 201) {
        // Prepend the new comment to the comments array
        setComments((prevComments) => ({
          ...prevComments,
          [caseID]: [result.data, ...(prevComments[caseID] || [])],
        }));
        // Clear the specific comment input for this case
        setCommentValues((prev) => ({
          ...prev,
          [caseID]: "",
        }));
      }
    } catch (error) {
      console.log({ error });
    }finally{
      setSending(null)
    }
  };

  const toggleComments = async (postId) => {
    if (!comments[postId]) {
      await fetchComments(postId, 1);
    }
    setCommentsPage((prevState) => ({
      ...prevState,
      [postId]: 1,
    }));
  };

  const fetchComments = async (postId, page) => {
    const newOffset = (page - 1) * 10;
    setCommentLoading(true);
    const response = await fetchApi.get(
      `case-comment/?ordering=-created_at&case_id=${postId}&offset=${newOffset}&page=${page}`
    );
    setComments((prevState) => ({
      ...prevState,
      [postId]: [...(prevState[postId] || []), ...response?.data?.results],
    }));
    setCommentLoading(false);
    setHasMoreComments(response?.data?.next != null);
  };

  const loadMoreComments = async (postId) => {
    const nextPage = commentsPage[postId] + 1;
    await fetchComments(postId, nextPage);
    setCommentsPage((prevState) => ({
      ...prevState,
      [postId]: nextPage,
    }));
  };

  useEffect(() => {
    const GetCases = async () => {
      const newOffset = (page - 1) * itemPerPage;
      setIsLoading(true);
      try {
        let result;
        if (currentTab === "Approved") {
          result = await fetchApi.get(
            `case/?ordering=created_at&is_approved=true&limit=${itemPerPage}&offset=${newOffset}&page=${page}&pageSize=${itemPerPage}`
          );
        } else {
          result = await fetchApi.get(
            `case/?ordering=created_at&status=${currentTab.toLowerCase()}&limit=${itemPerPage}&offset=${newOffset}&page=${page}&pageSize=${itemPerPage}`
          );
        }
        if (result?.status === 200) {
          let results = result?.data?.results;
          setFeeds((prevFeeds) =>
            page === 1 ? results : [...prevFeeds, ...results]
          );
          setHasMore(result?.data?.results?.length > 0);
        }
      } catch (error) {
        console.log({ error });
      }finally{
      setIsLoading(false);
      }
    };

    if (initialRender.current) {
      initialRender.current = false;
      GetCases();
    } else {
      GetCases();
    }
  }, [page, currentTab]);

  useEffect(() => {
    // Reset the page to 1 whenever the currentTab changes
    setPage(1);
  }, [currentTab]);

  useEffect(() => {
    const fetchCommentsCounts = async () => {
      const counts = {};
      for (const feed of feeds) {
        const response = await fetchApi.get(
          `case-comment/?case_id=${feed?.id}`
        );
        counts[feed.id] = response?.data?.count;
      }
      setCommentsCounts(counts);
    };
    fetchCommentsCounts();
  }, [feeds, comments]);

  useEffect(() => {
    const fetchDonationsCounts = async () => {
      const counts = {};
      for (const feed of feeds) {
        const response = await fetchApi.get(
          `case-specific-donation/?case_id=${feed?.id}`
        );
        counts[feed.id] = response?.data?.count;
      }
      setDonationsCounts(counts);
    };
    fetchDonationsCounts();
  }, [feeds]);

  const fetchMoreData = () => {
    setPage((prevPage) => prevPage + 1);
  };

  const toggleDescription = (index) => {
    setShowFullDescription((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  const handleEdit = (data) => {
    setIsEditing(true);
  };

  const handleEditData = async () => {
    const data = {};
    const result = await fetchApi.post("/", data);
  };

  const formatDate = (d) => {
    const dateString = d;
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  const inputRef = useRef(null);

  const [activeEmojiPicker, setActiveEmojiPicker] = useState(null); // track active feed ID

  const handleEmojiClick = (postId, emojiData) => {
    setCommentValues((prev) => ({
      ...prev,
      [postId]: (prev[postId] || "") + emojiData.emoji,
    }));
    setActiveEmojiPicker(null); // close after choosing
  };

  const handleDeleteCmnt = async (id, cmnt) => {
    const caseId = cmnt?.case_id;
    try {
      setComments((prev) => ({
        ...prev,
        [caseId]: (prev[caseId] || []).filter((c) => c.id !== id),
      }));
      const response = await fetchApi.delete(`case-comment/${id}/`);
      if (response?.status === 204) {
        toast.success("Comment deleted successfully");
      }
    } catch (error) {
      toast.error("Something went wrong while delete comment");
    }
  };

  const renderMediaContent = (attachments) => {
    let images = [];
    let videos = [];
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "bmp", "svg"];
    const videoExtensions = [
      "mp4",
      "avi",
      "mov",
      "mkv",
      "wmv",
      "flv",
      "webm",
      "mpeg",
      "m4v",
    ];
    attachments.forEach((file) => {
      if (file?.file !== null) {
        const fileNameParts = file?.file?.split(".");
        const fileExtension = fileNameParts[fileNameParts.length - 1];
        if (imageExtensions.includes(fileExtension)) {
          images.push(file?.file);
        } else if (videoExtensions.includes(fileExtension)) {
          videos.push(file?.file);
        }
      }
    });
    return (
      <>
        {images?.length === 1 && videos?.length === 1 ? (
          <div className="flex md:flex-row flex-col gap-2">
            <img
              src={images[0]}
              onClick={() => toggleShowmodel(images, videos)}
              key={98}
              className="md:w-1/2 w-full md:h-80 h-60 object-cover cursor-pointer"
              alt="post-img"
              element-index={0}
            />
            <video
              onClick={() => toggleShowmodel(images, videos)}
              className="md:w-1/2 w-full md:h-80 h-60 object-cover cursor-pointer"
              src={videos[0]}
              controls
            />
          </div>
        ) : (
          <div className="flex md:flex-row  flex-col gap-2">
            {images?.slice(0, 2).map((image, index) => (
              <div
                className={`image-overlays md:w-1/2 w-full md:h-80 h-60 object-cover relative `}
                key={index}
              >
                <img
                  src={image}
                  onClick={() => toggleShowmodel(images, videos)}
                  id={image.id}
                  key={index}
                  alt="post-img"
                  element-index={index}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    cursor: "pointer",
                  }}
                />
                {images?.length > 1 && index === 1 && (
                  <div
                    className={`overlay overlay-${index + 1}`}
                    element-index={index}
                    onClick={() => toggleShowmodel(images, videos)}
                  >
                    + {images?.length - 1}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </>
    );
  };

  return (
    <>
    
    <Helmet>
<title>KWF Projects | Building Hope, One Community at a Time</title>
<meta name="description" content="See KWF’s ongoing and completed projects delivering food, housing, clothing, education and health services to strengthen communities in need"/>
</Helmet>
      {showModel && (
        <div className="z-10 top-0 left-0 right-0 fixed">
          <div
            className="bg-gray-950 bg-opacity-95 h-full w-full fixed"
            onClick={() => {
              setShowModel(false);
            }}
          ></div>
          <CasePostModel
            setShowModel={setShowModel}
            postImages={postImages}
            postVideos={postVideos}
          />
        </div>
      )}
      {isEditing && (
        <div className="z-20 top-0 left-0 right-0 fixed">
          <div className="bg-gray-950 bg-opacity-95 h-full w-full fixed"></div>
          <div className="flex justify-center items-center h-screen w-full">
            <div className="md:w-1/2 w-11/12 bg-white p-8  rounded shadow-lg relative">
              <h2 className="text-center">Edit Case</h2>
              <div className="flex items-center gap-2">
                <span className="font-semibold">Title:</span>
                {editFeed?.title}
              </div>
              <div className="flex gap-2 items-center">
                <span className="font-semibold">Created date:</span>
                {formatDate(editFeed?.created_at)}
              </div>
              <form onSubmit={handleEditData} className="form_responsive">
                <div className="field-container py-2">
                  <h6>Status</h6>
                  <select
                    type="text"
                    id="status"
                    name="status"
                    placeholder="Status"
                    className="formField custom-select w-100"
                    value={formValues?.status}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        status: e.target.value,
                      })
                    }
                    defaultValue={editFeed?.status}
                    required
                  >
                    <option value="completed">completed</option>
                    <option value="declined">reject</option>
                    <option value="in-progress">in-progress</option>
                  </select>
                </div>
                <div className="field-container py-2">
                  <h6 className="">Approved</h6>
                  <select
                    type="text"
                    id="approved"
                    name="approved"
                    placeholder="Approved"
                    className="formField custom-select w-100"
                    value={formValues?.approved}
                    onChange={(e) =>
                      setFormValues({
                        ...formValues,
                        approved: e.target.value,
                      })
                    }
                    defaultValue={editFeed?.is_approved}
                    required
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
                <div className="flex gap-2 justify-end">
                  <button
                    className="bg-[#DE1285] w-auto rounded-3xl"
                    type="submit"
                  >
                    save
                  </button>
                  <button
                    className="bg-[#DE1285] w-auto rounded-3xl"
                    onClick={() => setIsEditing(false)}
                  >
                    cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
      <Navbar />
      <Banner
        title={"Cases Feeds"}
        text={`Ongoing welfare and community development project under KWF.`}
      />
      <div className="bg-white min-h-screen max-w-screen-xl mx-auto">
        <div className="flex items-center justify-center flex-col px-[16px]">
          <div className="w-full flex items-center justify-between sm:gap-4 gap-2 md:mb-5 mb-2 mt-8">
            {/* Search */}
            <div className="relative flex justify-center border rounded-full sm:py-2 py-1 px-2 sm:w-[400px] w-full bg-[#FCFBF7] items-center gap-2">
              <FaSearch className=" text-gray-400" />
              <input
                type="search"
                name="search"
                className=" py-1 border-none bg-transparent w-full outline-none"
                placeholder="Search here..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>

            <div className="flex items-center gap-4">
              {/* Tabs */}
              <ul className="lg:flex hidden gap-2 sm:gap-4 justify-center bg-[#FCFBF7] border border-gray-400 px-[2px] py-[2px] mb-0 rounded-full">
                {["Approved", "In-Progress", "New", "Completed"].map((tab) => (
                  <li key={tab}>
                    <div
                      onClick={() => setCurrentTab(tab)}
                      className={`px-4 py-2 text-sm sm:text-base font-medium cursor-pointer ${
                        currentTab === tab
                          ? "bg-primary-green rounded-full text-white"
                          : " text-gray-700 hover:bg-gray-100 bg-transparent border-none"
                      }`}
                    >
                      {tab}
                    </div>
                  </li>
                ))}
              </ul>

              <Link to="#">
                <div
                  className="sm:text-base text-xs primary-button"
                  onClick={() => setNewCaseModalOpen(true)}
                >
                  Post New Case
                </div>
              </Link>
            </div>
          </div>
          <ul className="flex gap-2 lg:hidden sm:gap-4 mb-6 w-full justify-between bg-[#FCFBF7] border border-gray-400 px-[2px] py-[2px] rounded-full">
            {["Approved", "In-Progress", "New", "Completed"].map((tab) => (
              <li key={tab}>
                <div
                  onClick={() => setCurrentTab(tab)}
                  className={`px-1.5 py-2 text-xs sm:text-base font-medium cursor-pointer ${
                    currentTab === tab
                      ? "bg-primary-green rounded-full text-white"
                      : " text-gray-700 hover:bg-gray-100 bg-transparent border-none"
                  }`}
                >
                  {tab}
                </div>
              </li>
            ))}
          </ul>

          {/* Loading State */}
          {isLoading ? (
            <div className="flex flex-col items-center justify-center py-10">
              <Lottie animationData={Loader} className="w-24 h-24" />
              <p className="text-gray-500 mt-3">Loading feeds...</p>
            </div>
          ) : feeds.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-16">
              <p className="text-gray-500 font-medium text-lg">
                No cases found
              </p>
            </div>
          ) : (
            <div className="mt-4">
              {/* Feed Cards */}
              {feeds.map((item, index) => (
                <div
                  key={index}
                  className="bg-[#FCFBF7] w-full rounded-xl border border-[#BFC1C4] shadow-sm p-4 mb-6"
                >
                  {/* Header */}
                  <div className="flex items-center">
                    <div className="rounded-full bg-[#147D50] text-white font-bold w-12 h-12 flex items-center justify-center">
                      KWF
                    </div>
                    <div className="ml-3">
                      <h4 className="font-semibold text-base sm:text-lg">
                        Khadim Welfare Foundation
                      </h4>
                      <p className="text-sm text-gray-500">
                        {formatDate(item?.created_at)}
                      </p>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-gray-700 text-sm mt-3">
                    {showFullDescription[index]
                      ? item.description
                      : item.description.length > 200
                      ? `${item.description.slice(0, 200)}...`
                      : item.description}
                    {item.description.length > 200 && (
                      <span
                        className="text-green-600 font-semibold cursor-pointer"
                        onClick={() => toggleDescription(index)}
                      >
                        {showFullDescription[index] ? " See less" : " See more"}
                      </span>
                    )}
                  </p>

                  {/* Media */}
                  <div className="mt-3 rounded-lg overflow-hidden">
                    {renderMediaContent(item?.attachment_before_completion)}
                  </div>

                  {/* Stats Row */}
                  <div className="flex items-center justify-between text-sm text-gray-600 mt-3">
                    {/* Left: Likes */}
                    <div className="flex items-center gap-4">
                    <div className="flex items-center gap-2 font-semibold">
                      <FaHeart size={24} className="text-red-600" /> 320k
                    </div>
                    <div className="flex items-center gap-2 font-semibold cursor-pointer"   onClick={() => {
                        setIsShowComment(
                          isShowComment === item.id ? null : item.id
                        );
                        toggleComments(item.id);
                      }}>
                      <TbMessage size={20} className="text-gray" />  {commentsCounts[item.id] || 0}
                    </div>
                    </div>

                    {/* Right: Comments Count */}
                    <div
                      className="flex items-center gap-2 font-semibold cursor-pointer"
                      // onClick={() => {
                      //   setIsShowComment(
                      //     isShowComment === item.id ? null : item.id
                      //   );
                      //   toggleComments(item.id);
                      // }}
                    >
                      <LuSend size={24} className="text-gray" onClick={(e)=>submitComment(e, item.id)} />{" "}
                     
                    </div>
                  </div>

                  {/* Comment Section (expand/collapse) */}
                  {isShowComment === item.id && (
                    <div className="mt-4">
                      {/* Already Loaded Comments */}
                      {commentLoading ? (
                        <p className="text-gray-500 text-sm">
                          Loading comments...
                        </p>
                      ) : comments[item.id] && comments[item.id].length > 0 ? (
                        <div className="flex flex-col gap-3 mb-4">
                          {comments[item.id].map((cmnt) => (
                            <div
                              key={cmnt.id}
                              className="flex items-start gap-3 border-b pb-2"
                            >
                              <FaUserCircle
                                size={28}
                                className="text-gray-400"
                              />
                              <div className="flex-1">
                                <p className="text-gray-800 text-sm font-medium">
                                  {cmnt?.user?.username || "Anonymous"}
                                </p>
                                <p className="text-gray-600 text-sm">
                                  {cmnt.text}
                                </p>
                              </div>
                              <MdDelete
                                className="text-red-500 cursor-pointer"
                                onClick={() => handleDeleteCmnt(cmnt.id, cmnt)}
                              />
                            </div>
                          ))}
                          {hasMoreComments && (
                            <button
                              className="text-sm text-green-600 font-semibold"
                              onClick={() => loadMoreComments(item.id)}
                            >
                              Load more comments
                            </button>
                          )}
                        </div>
                      ) : (
                        <p className="text-gray-500 text-sm mb-4">
                          No comments yet. Be the first!
                        </p>
                      )}

                    </div>
                  )}

                    {/* Comment Input */}
                    <div
                        // onSubmit={(e) => submitComment(e, item.id)}
                        className="relative"
                      >
                        <div className="flex items-center gap-2 pt-3">
                          <FaUserCircle size={30} className="text-gray-500" />

                          <div className="py-2 px-2 flex items-center gap-3 w-full rounded-xl border border-gray-300">
                            <input
                              type="text"
                              placeholder="Write your comment"
                              value={commentValues[item.id] || ""}
                              onChange={(e) =>
                                setCommentValues((prev) => ({
                                  ...prev,
                                  [item.id]: e.target.value,
                                }))
                              }
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  if (!commentValues[item.id]?.trim()) {
                                    toast.error("Please write a comment");
                                    return;
                                  }
                                  submitComment(e, item.id);
                                }
                              }}                            
                              className="flex-1 text-base font-normal border-none focus:outline-none bg-transparent"
                            />

                            {/* Emoji Icon */}
                            <BsEmojiSmile
                              className="text-gray-500 cursor-pointer"
                              onClick={() =>
                                setActiveEmojiPicker(
                                  activeEmojiPicker === item.id ? null : item.id
                                )
                              }
                            />
                          </div>

                          {/* Submit Button */}
                          {/* <button
                            type="submit"
                            className="w-max bg-transparent shadow-none"
                          >
                            {sending === item?.id ? 
<div role="status">
    <svg aria-hidden="true" class="w-6 h6 text-gray-200 animate-spin fill-black" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
</div>
:

                            <BsFillSendFill size={24} className="text-gray cursor-pointer" />}
                          </button> */}
                        </div>

                        {/* Emoji Picker Popup */}
                        {activeEmojiPicker === item.id && (
                          <div className="absolute bottom-12 right-10 z-50">
                            <EmojiPicker
                              onEmojiClick={(emoji) =>
                                handleEmojiClick(item.id, emoji)
                              }
                            />
                          </div>
                        )}
                      </div>
                </div>
              ))}
            </div>
          )}

       
        </div>
      </div>

      <Footer />
      {newCaseModalOpen && (
        <PostCase
          showModal={newCaseModalOpen}
          setShowModal={setNewCaseModalOpen}
        />
      )}
    </>
  );
};

export default CasesFeeds;
